export default __webpack_public_path__ + "static/media/downloadArrow.fb7b4408.svg";